/* ==========================================================================
   Card Product v2  |  assets/card-product-v2.js
   Loaded (deferred) by snippets/card-product.liquid. Safe to load many times.
   - Variant change: updates price, compare-at, save badge, % off, unit price,
     hidden variant id, add-to-cart / sold-out state (all in the new INR format)
   - Collection mobile: dropdown shows only the variant name ("250 ml");
     everywhere else it shows "250 ml · Rs 859"
   ========================================================================== */
(function () {
  if (window.__cpV2) return;
  window.__cpV2 = true;

  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };

  function setAll(card, selector, text) {
    var els = card.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      /* never overwrite the dropdown <option> labels (they carry the same data-cp-* attributes) */
      if (els[i].tagName === 'OPTION') continue;
      els[i].textContent = text;
    }
  }

  function apply(select) {
    var card = select.closest('.cp');
    var opt = select.options[select.selectedIndex];
    if (!card || !opt) return;
    var d = opt.dataset;
    var hasDiscount = !!d.cpSave;
    var available = d.cpAvailable !== 'false';

    setAll(card, '[data-cp-price]', d.cpPrice || '');
    setAll(card, '[data-cp-compare]', d.cpCompare || '');

    var price = card.querySelector('.price');
    if (price) {
      price.classList.toggle('price--on-sale', hasDiscount);
      price.classList.toggle('price--sold-out', !available);
    }

    var saves = card.querySelectorAll('[data-save-text]');
    for (var i = 0; i < saves.length; i++) {
      saves[i].textContent = hasDiscount ? 'Save ' + d.cpSave : '';
      saves[i].style.display = hasDiscount ? '' : 'none';
    }
    setAll(card, '[data-cp-off]', hasDiscount && d.cpOff ? d.cpOff + '% off' : '');

    var unit = card.querySelector('.unit-price');
    if (unit) {
      setAll(unit, '[data-cp-unit]', d.cpUnit || '');
      unit.classList.toggle('hidden', !d.cpUnit);
    }

    var ids = card.querySelectorAll('.product-variant-id');
    for (var j = 0; j < ids.length; j++) ids[j].value = select.value;

    var btn = card.querySelector('.cp__add[type="submit"]');
    if (btn) {
      btn.disabled = !available;
      var label = btn.querySelector('.cp__label');
      if (label) label.textContent = available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
    }

    /* sold out variant: hide add to cart, show "Notify me when back" */
    var addForm = card.querySelector('.cp__form');
    if (addForm) addForm.hidden = !available;
    var notify = card.querySelector('[data-cp-notify]');
    if (notify) {
      notify.hidden = available;
      var nbody = notify.querySelector('[name="contact[body]"]');
      if (nbody) {
        var vt = d.cpVtitle && d.cpVtitle !== 'Default Title' ? ' - ' + d.cpVtitle : '';
        nbody.value = 'Notify me when back in stock: ' + (notify.getAttribute('data-title') || '') + vt +
          ' | ' + (notify.getAttribute('data-url') || '') + '?variant=' + select.value;
      }
    }
  }

  function setLabels(root) {
    var selects = (root || document).querySelectorAll('.cp:not(.cp--tab) .cp__select');
    for (var i = 0; i < selects.length; i++) {
      var opts = selects[i].options;
      for (var k = 0; k < opts.length; k++) {
        var text = mq.matches ? opts[k].getAttribute('data-label-short') : opts[k].getAttribute('data-label-full');
        if (text) opts[k].textContent = text;
      }
    }
  }

  function init(root) {
    var selects = (root || document).querySelectorAll('.cp__select');
    for (var i = 0; i < selects.length; i++) apply(selects[i]);
    setLabels(root);
  }

    window.__cpV2Init = init; /* used by "Load more products" to set up newly added cards */

  document.addEventListener('change', function (e) {
    var select = e.target && e.target.closest ? e.target.closest('.cp__select') : null;
    if (select) apply(select);
  });

  /* Notify me when back: open / close the email form */
  document.addEventListener('click', function (e) {
    var toggle = e.target && e.target.closest ? e.target.closest('[data-cp-notify-toggle]') : null;
    if (!toggle) return;
    var wrap = toggle.closest('[data-cp-notify]');
    if (!wrap) return;
    var open = !wrap.classList.contains('is-open');
    wrap.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      var input = wrap.querySelector('.cp__ninput');
      if (input) input.focus();
    }
  });

  /* Notify me when back: send the email through the store contact form */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.cp__notify-form') : null;
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation(); /* captcha / tracking scripts must not re-submit the form */
    form.submit = function () { return false; }; /* block any script that calls form.submit() */

    var msg = form.querySelector('.cp__nmsg');
    var input = form.querySelector('.cp__ninput');
    var submit = form.querySelector('.cp__nsubmit');
    function say(text, isError) {
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
    }

    if (!input.value || !input.checkValidity()) {
      say('Please enter a valid email address.', true);
      input.focus();
      return;
    }

    /* put the customer's email at the top of the message body (the form sender is the store) */
    var bodyField = form.querySelector('[name="contact[body]"]');
    if (bodyField) {
      bodyField.value = bodyField.value.replace(/^Customer email: .*\n/, '');
      bodyField.value = 'Customer email: ' + input.value + '\n' + bodyField.value;
    }

    submit.disabled = true;
    say('', false);
    var params = new URLSearchParams(new FormData(form));
    params.delete('cp_customer_email'); /* already inside the message body */

    fetch(form.action.split('#')[0], {
      method: 'POST',
      body: params,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'text/html' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        console.log('[notify]', res.status, res.url); /* debug: remove later */

        /* Shopify spam check */
        if ((res.url || '').indexOf('/challenge') > -1) {
          say('Security check needed. Please wait a minute and try again.', true);
          return;
        }
        /* server error = real failure */
        if (res.status >= 500) {
          say('Could not send. Please try again.', true);
          return;
        }
        /* Shopify answers 400 even when the mail is delivered, so anything else counts as sent */
        say("Thanks! We'll email you when it's back in stock.", false);
        form.classList.add('is-done');
        input.value = '';
      })
      .catch(function (err) {
        console.error('[notify]', err);
        say('Something went wrong. Please try again.', true);
      })
      .then(function () { submit.disabled = false; });
  }, true); /* capture phase: runs before any other submit handler */
  if (mq.addEventListener) mq.addEventListener('change', function () { setLabels(); });
  else if (mq.addListener) mq.addListener(function () { setLabels(); });

  function run() {
    init();
    /* other theme scripts (card-variant-picker.js) may touch the price after load: re-apply once */
    window.setTimeout(init, 120);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
